export default {
    maintenancewarningevent_main_title: 'Maintenance Warning Events',
    maintenancewarningevent_main_esn: 'Serial',
    maintenancewarningevent_main_label: 'Name',
    maintenancewarningevent_main_linkedMode: 'Mode',
    maintenancewarningevent_main_linkedUnitLabel: 'Paired Unit',
    maintenancewarningevent_main_unitTime: 'Unit Time',
    maintenancewarningevent_main_warning: 'Warning',
    maintenancewarningevent_main_value: 'Value',
    maintenancewarningevent_main_no_data: 'No data available',
    maintenancewarningevent_main_details: 'Details',
    maintenancewarningevent_main_company: 'Company',
}